<script>
    import Button from "./base/Button.svelte";

    export let title;
    export let subtitle;
    export let className;
    document.title = title;
</script>

<div class="space-y-4 {className}">
    <p class="text-5xl sm:text-6xl font-bold tracking-wide">
        {title}
    </p>
    <p class="text-lg 2xl:text-3xl font-extralight whitespace-pre-line">{subtitle}</p>
    <div class="w-full pt-4">
        <Button href="#about" full plain color="secondary">
            <span class="mr-2">📞</span>Contactez moi
        </Button>
    </div>
</div>
